<template>
  <div class="pages-contain">
    <div class="company-contain">
      <div class="company-left">
        <img src="../../../../static/images/server6.png" alt="公司简介" />
      </div>
      <div class="company-right">
        <div class="company-title">
          <h1>深圳市高扬生物科技有限公司</h1>
          <h2>Shenzhen Gaoyang Biotechnology Co., Ltd.</h2>
        </div>
        <div class="company-writing">
          深圳市高扬生物科技有限公司是一家终端用户综合服务平台公司，
          以“合作库平台”与
          “派单服务平台”为依托，打造产品服务和现场服务于一体的新型商业模式。涉足行业包括医疗设备、金融设备领域。
        </div>
        <div class="company-writing">
          合作库是设备配件资源共享平台。通过电子商务的模式整合客户库存资源和多方渠道资源，同时以供应链标准化管理体系为基础，对产品进行标准化管理，使其具备流通和交易的基础，平台为多方需求者提供统一标准化的优质产品，帮助用户把人员管理和配件管理进行分离，有效降低管理成本和备件支出成本。
        </div>
        <div class="company-writing">
          派单服务是人力资源共享平台。为企业客户提供端到端的服务交付和服务管理，可实现现场服务的实时监管和按单结算。我们的业务包括但不限于：售后、安装、维修、驻点、各类需人力现场服务的项目。我们拥有IT行业和金融行业遍布全国1-5级地区，使用企业级认证的2万多名工程师，和客户的人力资源覆盖形成互补，助企业提高末端服务效率及客户满意度。
        </div>
      </div>
    </div>
    <div class="companybtm-contain">
      <div class="figure-contain">
        <div class="interior-top"><span>2015</span><span>年</span></div>
        <div class="interior-bottom">前海高扬成立</div>
      </div>
      <div class="figure-contain">
        <div class="interior-top"><span>200</span><span>+</span></div>
        <div class="interior-bottom">国家和地区</div>
      </div>
      <div class="figure-contain">
        <div class="interior-top"><span>8</span><span>项</span></div>
        <div class="interior-bottom">核心服务</div>
      </div>
      <div class="figure-contain">
        <div class="interior-top"><span>300</span><span>万/人次</span></div>
        <div class="interior-bottom">高品质服务</div>
      </div>
    </div>
    <div class="environment">
      <h1>公司环境</h1>
      <h2>CORPORATE ENVIRONMENT</h2>
    </div>
    <div class="environment-details">
      公司以“资源共享、互利共赢”为经营理念，把客户的需求、用户的利益、员工的成长放在企业发展的首位，携手共创美好未来。
    </div>
    <div class="block">
      <el-carousel trigger="click" :interval="5000" height="548px">
        <el-carousel-item v-for="(item, index) in Data" :key="index">
          <img :src="item.img" :alt="item.alt" />
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Data: [
        {
          img: "../../../../static/images/banner-server1.png",
          alt: "公司办公区域"
        },
        { img: "../../../../static/images/banner-server2.jpg", alt: "公司门面" }
      ]
    };
  },
  created() {},

  methods: {}
};
</script>

<style scoped lang="less">
.pages-contain {
  width: 1170px;
  margin: 0 auto;
  padding-bottom: 100px;
  .company-contain {
    width: 100%;
    display: flex;
    flex-direction: row;
    .company-left {
      width: 55%;
      img {
        width: 100%;
        height: 645px;
        display: block;
      }
    }
    .company-right {
      width: 45%;
      height: 645px;
      .company-title {
        width: 100%;
        height: 160px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        h1 {
          font-size: 28px;
          font-weight: bold;
          color: #444444;
          line-height: 0;
        }
        h2 {
          font-size: 14px;
          color: #464646;
          font-family: "FZCYJ";
          letter-spacing: 1px;
          font-weight: 300;
          line-height: 0;
        }
      }
      .company-writing {
        margin-top: 20px;
        font-size: 13px;
        color: #868686;
        text-indent: 30px;
        letter-spacing: 1px;
        line-height: 26px;
      }
    }
  }
  .companybtm-contain {
    width: 100%;
    height: 190px;
    background: #fff;
    box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: row;
    .figure-contain {
      width: 25%;
      height: 190px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .interior-top {
        span:nth-of-type(1) {
          color: #464646;
          font-size: 52px;
          font-weight: bold;
        }
        span:nth-of-type(2) {
          color: #666666;
          font-size: 14px;
          vertical-align: top;
        }
      }
      .interior-bottom {
        color: #999999;
        font-size: 14px;
      }
    }
  }
  .environment {
    width: 100%;
    height: 180px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-bottom: 20px;
    h1 {
      font-size: 32px;
      font-weight: bold;
      color: #444444;
      line-height: 0;
    }
    h2 {
      font-size: 14px;
      color: #464646;
      font-family: "FZCYJ";
      letter-spacing: 1px;
      font-weight: 300;
      line-height: 0;
    }
  }
  .environment-details {
    width: 50%;
    height: 100px;
    margin: 0 auto;
    text-align: center;
    line-height: 24px;
    color: #666666;
    font-size: 14px;
  }
  .block {
    width: 100%;
    img {
      width: 970px;
      height: 548px;
      display: block;
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/About/common/companyAbout.vue